var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimboloCds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1216 13.8223C23.2084 13.8223 21.0425 16.2521 19.1557 18.2213L18.3666 19.082C17.4016 16.5592 14.6078 13.8213 11.8362 13.8213C8.5303 13.8213 6.20759 16.3773 6.20759 19.9379C6.21472 23.3697 8.83444 26.146 12.0589 26.1389L12.1479 26.1389C15.0985 26.1389 17.2649 23.709 19.1544 21.6986L19.8041 20.973C20.9463 23.2284 23.6938 26.1389 26.4738 26.1389C29.7802 26.1389 32.1011 23.5796 32.1011 19.937C32.0522 16.5095 29.4026 13.7725 26.1822 13.8232L26.1216 13.8223ZM12.1479 23.6682C10.2278 23.6602 8.6768 21.9967 8.68437 19.9531L8.68437 19.9398C8.68437 17.845 10.1036 16.3943 12.0687 16.2953C14.0151 16.1972 16.6259 17.5872 18.2606 19.1981L17.5842 19.9398C16.0444 21.4469 14.4306 23.6682 12.1479 23.6682ZM26.2788 23.7123C24.4989 23.7692 21.799 22.4422 19.8936 20.8782L20.7303 19.9408C22.1655 18.3986 23.8323 16.2611 26.2017 16.2962C28.0885 16.3076 29.6154 17.9327 29.6261 19.9408C29.6261 22.0768 28.4091 23.6431 26.2788 23.7123ZM37.7917 20C37.7917 31.0455 29.3781 40 18.9998 40C8.62159 40 0.208011 31.046 0.20801 20C0.208009 8.95403 8.62114 -7.35499e-07 18.9998 -1.64283e-06C29.3777 -2.55009e-06 37.7917 8.9545 37.7917 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimboloCds);
export default __webpack_public_path__ + "static/media/simbolo-cds.b828e60c87924131291ffb7a6a3eb943.svg";
export { ForwardRef as ReactComponent };